import { render, staticRenderFns } from "./VatsArray.vue?vue&type=template&id=2791b970&"
import script from "./VatsArray.vue?vue&type=script&lang=js&"
export * from "./VatsArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports